import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

const getAddressValue = (address) => {
    const retAddress = address.value || address;
    return retAddress;
};

export default class TFPACustomQuoteService {

    /**
     * Updates a custom quote coverage
     * @param {Object} customQuoteDTO CustomQuoteDataDTO
     * @param {Object} [additionalHeaders] additional headers to pass to the backend (e.g. auth)
     * @returns {Promise} a promise from the backend call with no result (if successful)
     */
    static updateCustomQuoteCoverages(customQuoteDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('customquote_tfpa'),
            'updateCustomQuoteCoverages',
            [customQuoteDTO],
            additionalHeaders
        );
    }

    /**
     * Updates a custom quote
     * @param {Object} customQuoteDTO CustomQuoteDataDTO
     * @param {Object} [additionalHeaders] additional headers to pass to the backend (e.g. auth)
     * @returns {Promise} a promise from the backend call with no result (if successful)
     */
    static updateCustomQuote(customQuoteDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('customquote_tfpa'),
            'updateCustomQuote',
            [customQuoteDTO],
            additionalHeaders
        );
    }

    //US26840
    static updateQuoteAndRetrievePaymentPlans(QuoteDataDTO, sessionUUID, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('quote_tfpa'),
            'updateQuoteAndRetrievePaymentPlans',
            [QuoteDataDTO, sessionUUID],
            additionalHeaders
        );
    }   

     /**
     * Updates a custom quote
     * @param {Object} SubmissionDTO SubmissionDTO
     * @param {Object} [additionalHeaders] additional headers to pass to the backend (e.g. auth)
     * @returns {Promise} a promise from the backend call with no result (if successful)
     */
    // US26847
    static submit(SubmissionDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('quote_tfpa'),
            'submit',
            [SubmissionDTO],
            additionalHeaders
        );
    } 
    
    static pickStandardizedYourHomeAddress(pickedAddress, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('addressstandardizationTFPA'),
            'pickStandardizedYourHomeAddress',
            [getAddressValue(pickedAddress)],
            additionalHeaders
        );
    }

    static bind(SubmissionDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('quote_tfpa'),
            'bind',
            [SubmissionDTO],
            additionalHeaders
        );
    }  
}
